import React from "react";
import Twitter from "../assets/twitter.svg";
import Facebook from "../assets/facebook.svg";

const SubmissionSuccess = ({ waitlistData, response }) => {
  const waitlistConfig = waitlistData.widget_config;
  const isDescriptionPresent = !!waitlistConfig.successTitle;
  const shouldShowPosition = waitlistConfig.showPosition || true;
  const showTwitterIcon =
    waitlistConfig?.socialMediaPostSubmission?.twitter || false;
  const showFacebookIcon =
    waitlistConfig?.socialMediaPostSubmission?.facebook || false;
  const shouldShowSocialMediaIcon = showTwitterIcon || showFacebookIcon;
  const waitlistPosition = response.position;

  return (
    <div className="p-5">
      <div
        className={`text-center text-3xl font-bold ${isDescriptionPresent ? "" : "mb-3"}`}
      >
        {waitlistConfig.successTitle ||
          "Successfully signed up to our waitlist"}
      </div>
      {waitlistConfig.successDescription && (
        <div className="my-3 text-center">
          {waitlistConfig.successDescription}
        </div>
      )}
      <div className="flex-1">
        <input
          type="text"
          className="mb-3 w-full rounded border p-2"
          readOnly={true}
          value={`${waitlistData.url}?ref=YOUR_REF_CODE`}
        />
      </div>
      {shouldShowPosition && (
        <div className="border-2 border-dotted p-4">
          <div className="text-center text-base">
            Your position in waitlist is
          </div>
          <div className="text-center text-xl">#{waitlistPosition}</div>
        </div>
      )}
      {shouldShowSocialMediaIcon && (
        <div className="mt-3 border-2 border-dotted p-4">
          <div className="text-center text-base">
            Refer your friends to get higher in waitlist!
          </div>
          <div className="mt-3 flex justify-center gap-1">
            {showTwitterIcon && (
              <img src={Twitter} alt="twitter" width={30} height={30} />
            )}
            {showFacebookIcon && (
              <img src={Facebook} alt="facebook" width={34} height={34} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmissionSuccess;
